export const successionPoolsSelector = state => state.successionPools;
